import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Constants} from '../shared/Helpers/constants';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';

@Injectable()
export class WorkflowService {
  private workflowUrl: string = environment.workflow_api_url;
  private headers: HttpHeaders;

  constructor(private _http: HttpClient) {
  }

  public getUserPromptResponse(requestId: string, workflowRunId: any, checkAdditionalInfo: boolean, elementId: any): Observable<any> {
    const url = `${this.workflowUrl}/api.workflow.net/workflowRun/${workflowRunId}/userPrompt/hasResponded?requestId=${requestId}&checkAdditionalInfo=${checkAdditionalInfo}&elementId=${elementId}`;
    return this._http.get(url);
  }

  public saveUserPromptResponse(userPromptResponse: string, requestId: string, workflowRunId: any, elementId: any, responderEmail: string) {
    const url = `${this.workflowUrl}/api.workflow.net/workflowRun/${workflowRunId}/element/${elementId}/userPrompt/response?userPromptResponse=${userPromptResponse}&requestId=${requestId}&responderEmail=${responderEmail}`;
    return this._http.put(url, null);
  }

  public getWorkflowByWorkflowRunId(workflowRunId: any): Observable<any> {
    const url = `${this.workflowUrl}/api.workflow.net/workflow-run/${workflowRunId}/workflows`;
    return this._http.get(url);
}

}
